import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var CreditCardIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M7.53003 8.88H41.0699C42.457 8.88 43.7874 9.43102 44.7682 10.4118C45.749 11.3926 46.3 12.7229 46.3 14.11V34.05C46.3 35.4371 45.749 36.7674 44.7682 37.7482C43.7874 38.729 42.457 39.28 41.0699 39.28H7.53003C6.14295 39.28 4.8126 38.729 3.83179 37.7482C2.85097 36.7674 2.30005 35.4371 2.30005 34.05V14.11C2.30005 12.7229 2.85097 11.3926 3.83179 10.4118C4.8126 9.43102 6.14295 8.88 7.53003 8.88ZM41.0699 11.38H7.53003C6.80772 11.38 6.11484 11.6662 5.60315 12.1761C5.09146 12.6859 4.80269 13.3777 4.80005 14.1V16.4H43.8V14.11C43.8 13.7515 43.7294 13.3965 43.5922 13.0653C43.455 12.7341 43.2539 12.4331 43.0004 12.1796C42.7469 11.9261 42.446 11.725 42.1147 11.5878C41.7835 11.4506 41.4285 11.38 41.0699 11.38ZM7.53003 36.78H41.0699C41.4293 36.78 41.7852 36.709 42.1171 36.5712C42.4489 36.4334 42.7503 36.2314 43.0039 35.9769C43.2575 35.7223 43.4585 35.4202 43.5951 35.0878C43.7317 34.7554 43.8014 34.3994 43.8 34.04V20.18H4.96997H4.80005V34.05C4.80005 34.774 5.08764 35.4684 5.59961 35.9804C6.11158 36.4924 6.80599 36.78 7.53003 36.78ZM31.15 23.21H32.86V26.63H31.15V23.21ZM36.28 23.21H34.5699V26.63H36.28V23.21ZM38 23.21H39.71V26.63H38V23.21Z"
  }));
});
CreditCardIcon.displayName = 'CreditCardIcon';
CreditCardIcon.defaultProps = {
  'aria-label': 'Credit Card'
};
export default CreditCardIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/CreditCardIcon/index.js
// module id = 1819
// module chunks = 12